<template>
  <div :class="$style.base" data-pw="button-group">
    <slot />
  </div>
</template>

<style module>
.base {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  *+& {
    margin-top: var(--space-md);
  }
}
</style>
